/* ===========================================================
   KITBOX PREMIUM CART
   Version 1.0
=========================================================== */

const KB = {

    FREE_SHIPPING: 1999,

    init() {

        this.bindButtons();

        this.loadRecentlyViewed();

        this.updateProgress();

        document.addEventListener('cart:refresh', () => {

            this.updateProgress();

            this.bindButtons();

        });

    },

    bindButtons() {

    document.querySelectorAll(".cart-add-btn").forEach((button) => {

        button.onclick = () => {

            const id = button.dataset.variant;

            if (!id) return;

            KB.addToCart(id, button);

        };

    });

},

    handleClick(e) {

        const id = e.currentTarget.dataset.variant;

        if (!id) return;

        e.currentTarget.disabled = true;

        e.currentTarget.innerHTML = 'Adding...';

        KB.addToCart(id, e.currentTarget);

    },

    async addToCart(id, button) {

    try {

        button.disabled = true;
        button.textContent = "Adding...";

        const response = await fetch("/cart/add.js", {

            method: "POST",

            headers: {
                "Content-Type": "application/json"
            },

            body: JSON.stringify({
                id: id,
                quantity: 1
            })

        });

        if (!response.ok) {
            throw new Error("Unable to add product");
        }

        // Reload the cart page so Shopify refreshes:
        // - cart items
        // - totals
        // - free shipping card
        // - checkout section
        window.location.reload();

    }

    catch (error) {

        console.error(error);

        button.disabled = false;
        button.textContent = "Add to Cart";

    }

},

    async refreshCart() {

        const res = await fetch('/cart.js');

        const cart = await res.json();

        document.dispatchEvent(

            new CustomEvent('kitbox:cartUpdated', {

                detail: cart

            })

        );

        this.updateProgress(cart);
        await this.refreshShippingCard();

        if (typeof window.refreshCartDrawer === 'function') {

            window.refreshCartDrawer();

        }

    },
    async refreshShippingCard() {

    const response = await fetch(window.location.pathname);

    const html = await response.text();

    const parser = new DOMParser();

    const doc = parser.parseFromString(html, "text/html");

    const newCard = doc.querySelector("#kitbox-shipping-wrapper");

    const currentCard = document.querySelector("#kitbox-shipping-wrapper");

    if (newCard && currentCard) {

        currentCard.innerHTML = newCard.innerHTML;

    }

},

    async updateProgress(cart = null) {

        if (!cart) {

            const res = await fetch('/cart.js');

            cart = await res.json();

        }

        const total = cart.total_price / 100;

        const remaining = Math.max(

            this.FREE_SHIPPING - total,

            0

        );

        const percent = Math.min(

            (total / this.FREE_SHIPPING) * 100,

            100

        );

        document.querySelectorAll('.kb-progress-fill').forEach(bar => {

            bar.style.width = percent + '%';

        });

        document.querySelectorAll('.kb-progress-message').forEach(msg => {

            if (remaining > 0) {

                msg.innerHTML =

                    `🚚 You're only <strong>₹${remaining.toFixed(0)}</strong> away from <strong>FREE Shipping</strong>`;

            }

            else {

                msg.innerHTML =

                    `<span class="kb-success">🎉 Congratulations! You've unlocked FREE Shipping.</span>`;

            }

        });

    },

    saveRecentlyViewed(product) {

        let viewed =

            JSON.parse(

                localStorage.getItem('kb_recent')

            ) || [];

        viewed = viewed.filter(

            item => item.handle !== product.handle

        );

        viewed.unshift(product);

        viewed = viewed.slice(0, 4);

        localStorage.setItem(

            'kb_recent',

            JSON.stringify(viewed)

        );

    },

    loadRecentlyViewed() {

        const container =

            document.querySelector('.kb-recent');

        if (!container) return;

        const viewed =

            JSON.parse(

                localStorage.getItem('kb_recent')

            ) || [];

        if (!viewed.length) {

            container.parentElement.style.display = 'none';

            return;

        }

        container.innerHTML = '';

        viewed.forEach(product => {

            container.innerHTML += `

<div class="kb-recent-item">

<a href="${product.url}">

<img src="${product.image}" loading="lazy">

<div class="kb-recent-title">

${product.title}

</div>

</a>

</div>

`;

        });

    }

};

document.addEventListener(

    'DOMContentLoaded',

    () => KB.init()

);
(function () {

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {

        const response = await originalFetch.apply(this, args);

        try {

            const url = args[0].toString();

            if (
                url.includes('/cart/change') ||
                url.includes('/cart/update') ||
                url.includes('/cart/clear')
            ) {

                setTimeout(async () => {

                    const wrapper = document.querySelector('#kitbox-shipping-wrapper');

                    if (!wrapper) return;

                    const page = await fetch(window.location.pathname);

                    const html = await page.text();

                    const doc = new DOMParser().parseFromString(html, 'text/html');

                    const newWrapper = doc.querySelector('#kitbox-shipping-wrapper');

                    if (newWrapper) {
                        wrapper.innerHTML = newWrapper.innerHTML;
                    }

                }, 150);

            }

        } catch (e) {
            console.log(e);
        }

        return response;

    };

})();